<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图" />
    </div> -->
    <div class="top-row">
      <div class="menu">
        <!-- <p>服务中心</p> -->
        <p @click="linkClick1" class="image-hover">首页</p>
        <p @click="linkClick2" class="image-hover">关于我们</p>
        <p @click="linkClick3" class="image-hover">产品案例</p>
        <p @click="linkClick4" class="image-hover">联系我们</p>
      </div>
      <div class="contact">
        <p>联系方式</p>
        <!-- <p>电话: 400-8659-626</p> -->
        <!-- <p>电话: 027-88186963</p> -->
        <p>电话: 15527180052</p>
        <p>邮箱: sales@egaotech.com</p>
        <p>地址: 武汉市洪山区书城路56号</p>
      </div>
    </div>
    <div class="follow-us">
      <!-- <p>关注我们，获得更多资讯 添加好友，开启快速咨询</p> -->
    </div>
    <p class="copy">
      <!-- &copy; 版权所有 翼高天成有限公司<br /> -->
      <!-- &copy; 版权所有 武汉翼高天成科技有限公司<br /> -->
      版权所有 &copy; 武汉翼高天成科技有限公司<br />
      <span>鄂ICP备18018109号-1</span>
      <!-- <span>沪公网安备31011702009072号</span> -->
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    linkClick1() {
      this.$router.push({
        path: "/?id=0&name=首页",
      });
    },
    linkClick2() {
      this.$router.push({
        path: "/companyintroduction?id=1&name=关于我们",
      });
    },
    linkClick3() {
      this.$router.push({
        path: "/software/smartTown?id=2&name=虚拟仿真",
      });
    },
    linkClick4() {
      this.$router.push({
        path: "/contactus?id=3&name=联系我们",
      });
    },
  },
};
</script>

<style scoped>
/* 按钮图像动画 */
.image-hover {
  transition: all 0.3s ease-in-out;
}

.image-hover:hover {
  transform: scale(1.1);
  color: #b9e363;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 130px;
  height: 45px;
  margin: 50px auto 20px;
}

.top-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  padding-right: 25%; /* change to 25% */
}

.menu,
.contact {
  font-size: 14px;
  margin-bottom: 20px;
  text-align: left; /* change to left align */
}

.follow-us {
  font-size: 14px;
  margin-bottom: 20px;
  text-align: right; /* change to right align */
  width: 100%; /* set width to 100% */
}

.copy {
  color: #d3d3d3;
  font-family: Roboto;
  font-size: 14px;
  line-height: 21px;
  margin: 50px 0 10px;
  text-align: center;
}
.copy span:not(:last-child) {
  margin-right: 20px; /* adjust as needed */
}

@media screen and (max-width: 997px) {
  .top-row {
    flex-direction: column;
    padding-left: 0; /* remove the left padding on small screens */
  }
  .menu,
  .contact,
  .follow-us {
    font-size: 12px;
  }
  .copy {
    font-size: 10px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue